export const generateLinkToInstance = (company: {slug: string}) : string => {
  return `https://${company.slug || ''}.${localStorage.getItem('odash-app:domain-suffix')}`
}
